enum NotificationLinkTypeEnum {
	deeplink = 'deeplink',
	pickinglist = 'pickinglist'
}

export default NotificationLinkTypeEnum;
